import { render, staticRenderFns } from "./CompanyBuyer.vue?vue&type=template&id=6ae722ef&scoped=true&"
import script from "./CompanyBuyer.vue?vue&type=script&lang=js&"
export * from "./CompanyBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae722ef",
  null
  
)

export default component.exports